var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    "aria-hidden": "true",
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youtubeclip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36L0.880983 23.5623L7.41987 3.4377L28.5801 3.4377L35.119 23.5623L18 36Z",
    fill: "#FFE575"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8252 11.436C26.6819 11.6667 27.3574 12.3421 27.5879 13.1989C28.0164 14.7638 27.9999 18.0258 27.9999 18.0258C27.9999 18.0258 27.9999 21.2712 27.5881 22.8363C27.3574 23.6929 26.682 24.3684 25.8252 24.599C24.2602 25.011 18 25.011 18 25.011C18 25.011 11.7561 25.011 10.1747 24.5826C9.3179 24.3519 8.64254 23.6764 8.41183 22.8198C8 21.2712 8 18.0093 8 18.0093C8 18.0093 8 14.7638 8.41183 13.1989C8.64239 12.3422 9.33438 11.6503 10.1745 11.4197C11.7396 11.0077 17.9998 11.0077 17.9998 11.0077C17.9998 11.0077 24.2602 11.0077 25.8252 11.436ZM21.2117 18.009L16.0059 21.0074V15.0107L21.2117 18.009Z",
    fill: "#183029"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.e1a17613.svg";
export { ForwardRef as ReactComponent };